// Messages for portal/ShipmentDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.shipment_detail.head': '{shipment_no} — Portal',
  'portal.shipment_detail.back': 'Back to shipments',
  'portal.shipment_detail.export': 'Export',
  'portal.shipment_detail.summary': 'Shipment summary',
  'portal.shipment_detail.purchase_orders': '{po} purchase orders · {containers} container(s)',
  'portal.shipment_detail.etd_eta': 'ETD {etd} · ETA {eta}',
  'portal.shipment_detail.details': 'Shipment Details',
  'portal.shipment_detail.cargo': 'Cargo Details',
  'portal.shipment_detail.custom_fields': 'Custom Fields',
  'portal.shipment_detail.yes': 'Yes',
  'portal.shipment_detail.no': 'No',
  'portal.shipment_detail.cargo_total_weight': 'Total weight',
  'portal.shipment_detail.cargo_total_volume': 'Total volume',
  'portal.shipment_detail.spec.mbl': 'MBL',
  'portal.shipment_detail.spec.vessel': 'Vessel',
  'portal.shipment_detail.spec.hbl': 'HBL',
  'portal.shipment_detail.spec.voyage': 'Voyage',
  'portal.shipment_detail.spec.type': 'Shipment type',
  'portal.shipment_detail.spec.container_size': 'Container size',
  'portal.shipment_detail.spec.incoterm': 'Incoterm',
  'portal.shipment_detail.spec.weight': 'Gross weight',
  'portal.shipment_detail.spec.loading_port': 'Loading port',
  'portal.shipment_detail.spec.discharge_port': 'Discharge port',
  'portal.shipment_detail.spec.origin': 'Origin location',
  'portal.shipment_detail.spec.final_destination': 'Final destination',
  'portal.shipment_detail.spec.etc': 'ETC',
  'portal.shipment_detail.spec.ata': 'ATA date',
  'portal.shipment_detail.spec.etd': 'ETD',
  'portal.shipment_detail.spec.final_delivery': 'Final delivery date',
  'portal.shipment_detail.spec.eta_port': 'ETA to port',
  'portal.shipment_detail.spec.eta_final': 'ETA to final destination',
  'portal.shipment_detail.spec.pos': 'Purchase orders',
  'portal.shipment_detail.no_pos': 'No purchase orders',
  'portal.shipment_detail.tab.chat': 'Chat',
  'portal.shipment_detail.tab.docs': 'Documents',
  'portal.shipment_detail.tab.pkg': 'Packages',
  'portal.shipment_detail.tab.quote': 'Quote',
  'portal.shipment_detail.tracking': 'Tracking',
  // Chat
  'portal.shipment_detail.chat.empty': 'No messages yet — start the conversation.',
  'portal.shipment_detail.chat.aria': 'Message',
  'portal.shipment_detail.chat.placeholder': 'Message Geo4Logistics about this shipment…',
  'portal.shipment_detail.chat.visibility': 'Visible to your team & Geo4Logistics ops',
  'portal.shipment_detail.chat.send': 'Send',
  // Documents
  'portal.shipment_detail.docs.shared': 'Shared documents',
  'portal.shipment_detail.docs.upload': 'Upload document',
  'portal.shipment_detail.docs.empty': 'No shared documents yet.',
  'portal.shipment_detail.docs.download': 'Download {title}',
  'portal.shipment_detail.docs.notice': 'Documents shared with you by our team appear here.',
  // Packages
  'portal.shipment_detail.pkg.empty': 'No containers on this shipment.',
  'portal.shipment_detail.pkg.col.container': 'Container',
  'portal.shipment_detail.pkg.col.type': 'Type',
  'portal.shipment_detail.pkg.col.weight': 'Weight',
  'portal.shipment_detail.pkg.col.cbm': 'CBM',
  // Quote pane
  'portal.shipment_detail.quote.empty': 'No quote linked to this shipment.',
  'portal.shipment_detail.quote.linked_label': 'Linked quote',
  'portal.shipment_detail.quote.open': 'Open quote',
  'portal.shipment_detail.quote.notice':
    'Your agreed pricing for this shipment — visible only to your team.',
}

export const zhTW = {
  'portal.shipment_detail.head': '{shipment_no} — 客戶入口',
  'portal.shipment_detail.back': '返回貨件列表',
  'portal.shipment_detail.export': '匯出',
  'portal.shipment_detail.summary': '貨件摘要',
  'portal.shipment_detail.purchase_orders': '{po} 筆採購單 · {containers} 個貨櫃',
  'portal.shipment_detail.details': '貨件明細',
  'portal.shipment_detail.cargo': '貨物明細',
  'portal.shipment_detail.custom_fields': '自訂欄位',
  'portal.shipment_detail.yes': '是',
  'portal.shipment_detail.no': '否',
  'portal.shipment_detail.cargo_total_weight': '總重量',
  'portal.shipment_detail.cargo_total_volume': '總體積',
  'portal.shipment_detail.spec.mbl': 'MBL',
  'portal.shipment_detail.spec.vessel': '船名',
  'portal.shipment_detail.spec.hbl': 'HBL',
  'portal.shipment_detail.spec.voyage': '航次',
  'portal.shipment_detail.spec.type': '運輸類型',
  'portal.shipment_detail.spec.container_size': '貨櫃類型',
  'portal.shipment_detail.spec.incoterm': '貿易條件',
  'portal.shipment_detail.spec.weight': '毛重',
  'portal.shipment_detail.spec.loading_port': '裝貨港',
  'portal.shipment_detail.spec.discharge_port': '卸貨港',
  'portal.shipment_detail.spec.origin': '起運地',
  'portal.shipment_detail.spec.final_destination': '最終目的地',
  'portal.shipment_detail.spec.etc': 'ETC',
  'portal.shipment_detail.spec.ata': 'ATA 日期',
  'portal.shipment_detail.spec.etd': 'ETD',
  'portal.shipment_detail.spec.final_delivery': '最終送達日期',
  'portal.shipment_detail.spec.eta_port': '預計到港',
  'portal.shipment_detail.spec.eta_final': '預計到達最終目的地',
  'portal.shipment_detail.spec.pos': '採購單',
  'portal.shipment_detail.no_pos': '沒有採購單',
  'portal.shipment_detail.etd_eta': '預計出發 {etd} · 預計到達 {eta}',
  'portal.shipment_detail.tab.chat': '對話',
  'portal.shipment_detail.tab.docs': '文件',
  'portal.shipment_detail.tab.pkg': '包裝',
  'portal.shipment_detail.tab.quote': '報價',
  'portal.shipment_detail.tracking': '追蹤',
  'portal.shipment_detail.chat.empty': '尚無訊息 — 開始對話。',
  'portal.shipment_detail.chat.aria': '訊息',
  'portal.shipment_detail.chat.placeholder': '就此貨件傳訊息給 Geo4Logistics…',
  'portal.shipment_detail.chat.visibility': '您的團隊與 Geo4Logistics 營運團隊可見',
  'portal.shipment_detail.chat.send': '傳送',
  'portal.shipment_detail.docs.shared': '共享文件',
  'portal.shipment_detail.docs.upload': '上傳文件',
  'portal.shipment_detail.docs.empty': '尚無共享文件。',
  'portal.shipment_detail.docs.download': '下載 {title}',
  'portal.shipment_detail.docs.notice': '我們團隊與您共享的文件會顯示於此。',
  'portal.shipment_detail.pkg.empty': '此貨件沒有貨櫃。',
  'portal.shipment_detail.pkg.col.container': '貨櫃',
  'portal.shipment_detail.pkg.col.type': '類型',
  'portal.shipment_detail.pkg.col.weight': '重量',
  'portal.shipment_detail.pkg.col.cbm': 'CBM',
  'portal.shipment_detail.quote.empty': '此貨件未連結報價。',
  'portal.shipment_detail.quote.linked_label': '已連結報價',
  'portal.shipment_detail.quote.open': '開啟報價',
  'portal.shipment_detail.quote.notice': '此貨件的議定價格 — 僅限貴公司團隊查看。',
}
